import type { ModuleNav } from '@saas/ui';

const CUSTOMER_READ = ['crm.customer.read.own', 'crm.customer.read.team', 'crm.customer.read.all'];
const CUSTOMER_MANAGE = ['crm.customer.manage.own', 'crm.customer.manage.team', 'crm.customer.manage.all'];
const CONTACT_READ = ['crm.contact.read.own', 'crm.contact.read.team', 'crm.contact.read.all'];

/** crm のメニュー。管理メニューはカスタム項目の設定だけ（先方の部署・役割は各取引先の画面で扱う） */
export const crmNav: ModuleNav = {
  module: 'crm',
  items: [
    { label: '取引先', to: '/crm', icon: 'business', end: true, permission: CUSTOMER_READ, description: '会社・担当者・タイムライン' },
    { label: '連絡先', to: '/crm/contacts', icon: 'person', permission: CONTACT_READ, description: '氏名・電話・メールで探す' },
    { label: '名刺', to: '/crm/cards', icon: 'photo_camera', permission: ['crm.card.scan'], description: '撮る → 確認 → 登録' },
    { label: 'CSV 取込', to: '/crm/import', icon: 'upload', permission: CUSTOMER_MANAGE, description: 'Excel の一覧から取り込む' },
  ],
  admin: [
    // gap-crm-a: 連絡先の項目も同じ画面（タブ）で設定する
    { label: 'カスタム項目', to: '/crm/custom-fields', icon: 'list', permission: ['crm.customer.manage.all', 'crm.contact.manage.all'], description: '取引先・連絡先の編集フォームと CSV に出す項目' },
    // gap-crm-a: 名刺（連絡先）の一括名寄せ
    { label: '連絡先の名寄せ', to: '/crm/contacts/duplicates', icon: 'group', permission: ['crm.contact.manage.team', 'crm.contact.manage.all'], description: '重複の疑いがある人をまとめて統合する' },
  ],
};
